export const MAPBOX_TOKEN = import.meta.env.VITE_MAPBOX_TOKEN as string;

// STC is based in the Atlanta metro area
export const DEFAULT_CENTER: [number, number] = [-84.39, 33.75];
export const DEFAULT_ZOOM = 9;

export const MAP_STYLES = {
  light: "mapbox://styles/mapbox/light-v11",
  satellite: "mapbox://styles/mapbox/satellite-streets-v12",
  streets: "mapbox://styles/mapbox/streets-v12",
} as const;

export const DEFAULT_MAP_STYLE = MAP_STYLES.satellite;

export const CLUSTER_COLORS = {
  small: "#51bbd6",
  medium: "#f1f075",
  large: "#f28cb1",
};

export const ACCURACY_COLORS: Record<string, string> = {
  rooftop: "#22c55e",
  interpolated: "#3b82f6",
  approximate: "#eab308",
  centroid: "#eab308",
  failed: "#ef4444",
  unknown: "#94a3b8",
};
